import { hidde_preloader } from "@cozumel-reef-maps/web_general/js/ui/preloader.js";
import { view_login_members } from "@cozumel-reef-maps/web_general/js/ui/general_members.js";



export default function initLogin_Members(container) {
    console.log("Se ha cargado el módulo de Login.");
    
  view_login_members();
  hidde_preloader();
  


   
}




